import { SlaCounts } from './models/sla.models';

/**
 * Color bands from the Exec Dashboard "Key" legend / conditional formatting:
 *   90% to 100%  -> good (green)
 *   80% to 89.9% -> warning (amber)
 *   79.9% to 0%  -> miss (alert)
 *   blank        -> no band
 *
 * The Excel rules are `between` ranges (0.9–1, 0.8–0.899, 0–0.799) which leave
 * gaps at the boundaries (e.g. 89.95% matches no rule). We close them with >=.
 */
export type SlaBand = 'good' | 'warn' | 'miss';

export const SLA_BANDS: { band: SlaBand; label: string }[] = [
  { band: 'good', label: '90% to 100%' },
  { band: 'warn', label: '80% to 89.9%' },
  { band: 'miss', label: '79.9% to 0%' },
];

export function slaBand(pct: number | null): SlaBand | null {
  if (pct == null) return null;
  if (pct >= 0.9) return 'good';
  if (pct >= 0.8) return 'warn';
  return 'miss';
}

/**
 * % Met SLA, as computed in every table's H column:
 *   (Met SLA + Met SLA-WIP) / Total Tickets — blank when there are no tickets.
 */
export function pctMet(c: SlaCounts): number | null {
  return c.total === 0 ? null : (c.met + c.metWip) / c.total;
}

/** Sum rows into the Total row, exactly like the sheet's SUM() rows. */
export function sumCounts(rows: SlaCounts[]): SlaCounts {
  return rows.reduce(
    (acc, r) => ({
      total: acc.total + r.total,
      closed: acc.closed + r.closed,
      met: acc.met + r.met,
      missed: acc.missed + r.missed,
      metWip: acc.metWip + r.metWip,
      missedWip: acc.missedWip + r.missedWip,
    }),
    { total: 0, closed: 0, met: 0, missed: 0, metWip: 0, missedWip: 0 },
  );
}
